import React, { RefObject, forwardRef, useRef } from 'react'
import { useSafeState, useMount, useUpdate } from 'ahooks';

import { BottomNavBar } from '../home/navBar'

// -----------------------------------------------------------------------
const ShopPage = forwardRef((props = {}, ref) => {
    return (
        <div className="app">
            <div className='body'>
                <span>商城内容</span>
            </div>
            <BottomNavBar />
        </div>
    )
})





// -----------------------------------------------------------------------
export { ShopPage }